import { Box, RadioGroup, Typography } from '@mui/material';
import Radio from 'components/radio';
import React from 'react';

import { useStyles } from './styles';

type Props = {
  value: boolean | string | null,
  options: {
    label: string,
    disabled: boolean,
    value: string | number | boolean
  }[],
  onChange: (value: string) => void,
  title?: string,
  description?: string,
  onBlur?: any
}

export function RadioButtonForm({
  title,
  value,
  options,
  onChange,
  description,
  onBlur
}: Props) {
  const classes = useStyles();
  return (
    <Box style={{ flex: 1 }}>
      {title && (
        <Typography variant="h6" className={classes.title}>
          {title}
        </Typography>
      )}

      {description && (
        <Typography variant="body2" className={classes.subtitle}>
          {description}
        </Typography>
      )}

      <RadioGroup
        value={value}
        onChange={(e, valueSelected) => onChange(valueSelected)}
        onBlur={onBlur}
      >
        {options.map((option) => (
          <Radio
            key={String(option.value)}
            size="small"
            label={option.label}
            disabled={option.disabled}
            value={option.value}
          />
        ))}
      </RadioGroup>
    </Box>
  );
}
